import React from 'react';
import { FormattedMessage } from 'react-intl';

export const EMAIL_WITH_NAME_REGEXP = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/i;

export default (values) => {
  const errors = {};

  if (!values.emails) {
    errors.emails = (
      <FormattedMessage
        id="invites-form.errors.emails.required"
        defaultMessage="Email(s) required"
      />
    );
  }

  if (values.subject && values.subject.length > 300) {
    errors.subject = (
      <FormattedMessage
        id="invites-form.errors.subject.tooLong"
        defaultMessage="Subject must be less than 300 characters"
      />
    );
  }

  return errors;
};




// WEBPACK FOOTER //
// ./src/desktop/components/invite-people/validate.js